module.exports = __webpack_public_path__ + "img/elCalafate.fcd04b9a.jpg";